import DeviceDetector from './DeviceDetector';

const getLang = () => {
    const lang = {
        'es-es': 'es',
        'it-it': 'it',
        'en-gb': 'com',
    };
    return (window.WH.sportsbook.hasOwnProperty('lang')) ? lang[window.WH.sportsbook.lang] : lang['en-gb'];
};


const callback = async () => {
    const lang = getLang();
    const custHelpUrl = `https://williamhill-${lang}.custhelp.com`;
    const liveChatAuth = lang == 'es' ? 'LiveChatAuth ES' : 'LiveChatAuth IT';
    try {
        await window.WH.bootstrapper.features['live-chat-flow'
        ].activateEngagement({ name: liveChatAuth });
    } catch (e){
        let redirectUrl = custHelpUrl;
        if (DeviceDetector.isNativeiOS) {
            redirectUrl = `${custHelpUrl}/app/chat/chat_launch`;
        }
        window.open(redirectUrl); 
    }
};

const startCashierHandler = (event) => {
    const message = event.data;
    if (message === 'openCashierLiveChat') {
        callback();
    }
}; 

export default {
    init: () =>  {
        window.addEventListener('message', startCashierHandler);
    },
};
